import React from 'react'
import styled from 'styled-components'
import { AmplifyStyles } from '../../application/AmplifyStyles'
import { useEmailVerification } from '../../application/hooks/useEmailVerification'
import { SentryStyles } from '../../application/SentryStyles'
import { EmailVerification } from './EmailVerification'

interface EmailVerificationProps {
  children: React.ReactNode
}

export const EmailVerificationWrapper: React.FC<EmailVerificationProps> = ({ children }) => {
  const { isVerified, email, checkVerificationStatus } = useEmailVerification()

  if (isVerified || email === null) {
    return <>{children}</>
  }

  return (
    <>
      <SentryStyles />
      <AmplifyStyles />

      <VerificationContainer data-amplify-authenticator>
        <ContentContainer data-amplify-container>
          <Header>
            <HeaderStack>
              <img alt="tumelo" src="/images/Main_Logo_Tumelo_White-min.png" width="250" height="55" />
            </HeaderStack>
          </Header>
          <VerificationCard data-amplify-router>
            <EmailVerification email={email} onVerificationComplete={checkVerificationStatus} />
          </VerificationCard>
        </ContentContainer>
      </VerificationContainer>
    </>
  )
}

const VerificationContainer = styled.div`
  flex-grow: 1;
  display: grid;
  overflow: inherit;
  width: auto;
  height: 100vh;
`

const ContentContainer = styled.div`
  place-self: start center;
  margin-top: 10%;
  margin-bottom: 100px;
`

const VerificationCard = styled.div`
  border-radius: 8px;
  border-width: 0;
  background: white;
  padding: 32px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 400px;
`

const Header = styled.div`
  margin-bottom: 2.4rem;
`

const HeaderStack = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3.2rem;
`
